import moment from "moment"

class BaseCounter {
  protected counts: Record<string, number>
  constructor() {
    this.counts = {}
  }

  increment(key: string) {
    this.counts[key] = (this.counts[key] || 0) + 1
  }

  getCount(key: string) {
    return this.counts[key] || 0
  }

  hasCount(key: string) {
    return this.getCount(key) > 0
  }

  isEmpty() {
    return Object.keys(this.counts).length === 0
  }
}

export class ValidDateCounter extends BaseCounter {
  public format: string
  constructor(private sampling: "day" | "hour" = "day") {
    super()
    if (sampling === "hour") {
      this.format = "YYYY-MM-DD HH"
    } else if (sampling === "day") {
      this.format = "YYYY-MM-DD"
    } else {
      throw new Error("Invalid sampling type. Use 'hour' or 'day'.")
    }
  }

  static getKey(date: string | moment.Moment, sampling: "day" | "hour" = "day") {
    const format = sampling === "hour" ? "YYYY-MM-DD HH" : "YYYY-MM-DD"
    return moment.utc(date).startOf(sampling).format(format)
  }

  get validCountsByDate() {
    return this.counts
  }

  increment(date: string | moment.Moment) {
    const key = ValidDateCounter.getKey(date, this.sampling)
    super.increment(key)
  }

  getCount(date: string | moment.Moment) {
    const key = ValidDateCounter.getKey(date, this.sampling)
    return super.getCount(key)
  }
}
